import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';
import { allBomElementsAreSelected } from '../../enclosure/helpers/product.helper';

@Pipe({
    name: 'bomDirectFilterSelected',
    standalone: false
})
export class BomDirectFilterSelectedPipe implements PipeTransform {

  transform(bomModels: IBomModel[],
            selectedItems: number[],
            bomModelsAccessories: IBomModel[],
            selectedItemsAccessories: number[]): boolean {
    const allDirectBomModels = bomModels?.filter(bomModel => bomModel.article.deliverToCustomer);
    const allDirectBomAccessoriesModels = bomModelsAccessories?.filter(bomModel => bomModel.article.deliverToCustomer);

    return allBomElementsAreSelected(allDirectBomModels, selectedItems, allDirectBomAccessoriesModels, selectedItemsAccessories);
  }

}
